<div class="pix-container">
  <div class="pix-content">
    <img class="pix-qr" [src]="getSafeImage(getPixDetails().qrCode)" alt="QR Code Pix">
    <div class="pix-copy">
      <p [innerText]="getPixDetails().codigo"></p>
      <button [cdkCopyToClipboard]="getPixDetails().codigo" (cdkCopyToClipboardCopied)="onClipboardCopy($event)"
        class="btn-copy">
        Copiar
        <svg fill="#000000" height="20px" width="20px" viewBox="0 0 64 64">
          <g>
            <path d="M53.98,9.14H50.01c-0.08,0-0.16,0.03-0.23,0.05V5.02C49.78,2.25,47.47,0,44.64,0H10.22C7.38,0,5.08,2.25,5.08,5.02v46.84
              c0,2.77,2.3,5.02,5.14,5.02h6.04v2.27C16.25,61.83,18.47,64,21.20,64h32.78c2.73,0,4.94-2.17,4.94-4.84V13.99
              C58.92,11.32,56.70,9.14,53.98,9.14z M7.11,51.87V5.02c0-1.65,1.39-2.99,3.11-2.99h34.42c1.71,0,3.11,1.34,3.11,2.99v46.84
              c0,1.65-1.39,2.99-3.11,2.99H10.22C8.50,54.86,7.11,53.51,7.11,51.87z M56.89,59.16c0,1.55-1.31,2.81-2.91,2.81H21.20
              c-1.60,0-2.91-1.26-2.91-2.81v-2.27h26.35c2.83,0,5.14-2.25,5.14-5.02V11.13c0.08,0.02,0.15,0.05,0.23,0.05h3.97
              c1.60,0,2.91,1.26,2.91,2.81V59.16z" />
            <path d="M38.60,13.21H16.25c-0.56,0-1.02,0.45-1.02,1.02s0.46,1.02,1.02,1.02h22.35c0.56,0,1.02-0.45,1.02-1.02
              S39.16,13.21,38.60,13.21z" />
            <path d="M38.60,21.33H16.25c-0.56,0-1.02,0.45-1.02,1.02s0.46,1.02,1.02,1.02h22.35c0.56,0,1.02-0.45,1.02-1.02
              S39.16,21.33,38.60,21.33z" />
            <path d="M38.60,29.46H16.25c-0.56,0-1.02,0.45-1.02,1.02s0.46,1.02,1.02,1.02h22.35c0.56,0,1.02-0.45,1.02-1.02
              S39.16,29.46,38.60,29.46z" />
            <path d="M28.44,37.59H16.25c-0.56,0-1.02,0.45-1.02,1.02s0.46,1.02,1.02,1.02h12.19c0.56,0,1.02-0.45,1.02-1.02
              S29.01,37.59,28.44,37.59z" />
          </g>
        </svg>
      </button>
    </div>
    <p class="pix-vencimento" [innerText]="getVencimentoPix()"></p>
  </div>
</div>
